import { Injectable, inject } from '@angular/core';
import { Observable, defer, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { ProductV2 } from '../models/product-v2.model';
import { ProductV2Service } from '../services/product-v2.service';
import { sanitizeSlug } from '../utils/utils';

export function matchSimplifiedProducts(segment: string, products: ProductV2[]): ProductV2[] {
  return (products ?? []).filter(
    product => product.productType !== 'MIND' && sanitizeSlug(product.name) === segment
  );
}

export function matchSimplifiedProduct(
  segment: string,
  products: ProductV2[]
): ProductV2 | null {
  return matchSimplifiedProducts(segment, products)[0] ?? null;
}

@Injectable({ providedIn: 'root' })
export class SimplifiedProductMatchService {
  private readonly products = inject(ProductV2Service);

  private readonly catalog$ = defer(() => this.products.getProducts()).pipe(
    map(response => response?.data ?? []),
    catchError(() => of([] as ProductV2[])),
    shareReplay(1)
  );

  match(segment: string): Observable<ProductV2 | null> {
    return this.matchAll(segment).pipe(map(products => products[0] ?? null));
  }

  matchAll(segment: string): Observable<ProductV2[]> {
    return this.catalog$.pipe(map(products => matchSimplifiedProducts(segment, products)));
  }
}
